<!-- Header -->
<bmcore-color-block-header [groupTitle]="group.title" [currentGroupTitle]="currentGroupTitle">
</bmcore-color-block-header>

<!-- Main -->
@if (currentGroupTitle === group.title) {
  <div class="color-block__main">
    @for (key of Object.keys(getCurrentGroupByTitle().styleItems); track key; let i = $index) {
      <div>
        <!-- Color category: title and preview squares -->
        @if (group.styleItems[key].title !== appType) {
          <div
            class="color-block__category"
            (click)="changeColorSettings($event, key)"
            [ngClass]="{ 'color-block__category--active': key === currentStyleItemTitle }"
          >
            <!-- Title -->
            <p
              class="color-block__category-title"
              [ngClass]="{ 'color-block__category-title--active': key === currentStyleItemTitle }"
            >
              {{ i + 1 }}. {{ key }}
            </p>
            <!-- Preview squares -->
            <div class="color-block__category-color-box">
              @if (!!getStyleItemColors(key).color) {
                <div
                  [style.background]="getStyleItemColors(key).color"
                  class="color-block__category-preview-color"
                ></div>
              }
              @if (!!getStyleItemColors(key).bgColor) {
                <div
                  [style.background]="getStyleItemColors(key).bgColor"
                  class="color-block__category-preview-color"
                ></div>
              }
              @if (!!getStyleItemColors(key).borderColor) {
                <div
                  [style.background]="getStyleItemColors(key).borderColor"
                  class="color-block__category-preview-color"
                ></div>
              }
            </div>
          </div>
          <!-- Change color block: ngx-color-picker -->
          @if (currentStyleItemTitle === key) {
            <div class="color-block__ngx-picker" (click)="$event.stopPropagation()">
              @if (!!getCurrentStyleItemColors().color) {
                <label class="color-block__ngx-picker-label">
                  <input
                    class="color-block__ngx-picker-input"
                    [style.background]="getCurrentStyleItemColors().color"
                    (cpSliderDragEnd)="refreshStylesOnPage()"
                    (cpInputChange)="refreshStylesOnPage()"
                    [(colorPicker)]="getCurrentStyleItemColors().color"
                    readonly
                  />
                  <span class="color-block__ngx-picker-title">{{ lg.colorCustomizer.textColor }}</span>
                </label>
              }
              @if (!!getCurrentStyleItemColors().bgColor) {
                <label class="color-block__ngx-picker-label">
                  <input
                    class="color-block__ngx-picker-input"
                    [style.background]="getCurrentStyleItemColors().bgColor"
                    (cpSliderDragEnd)="refreshStylesOnPage()"
                    (cpInputChange)="refreshStylesOnPage()"
                    [(colorPicker)]="getCurrentStyleItemColors().bgColor"
                    readonly
                  />
                  <span class="color-block__ngx-picker-title">{{ lg.colorCustomizer.bgColor }}</span>
                </label>
              }
              @if (!!getCurrentStyleItemColors().borderColor) {
                <label class="color-block__ngx-picker-label">
                  <input
                    class="color-block__ngx-picker-input"
                    [style.background]="getCurrentStyleItemColors().borderColor"
                    (cpSliderDragEnd)="refreshStylesOnPage()"
                    (cpInputChange)="refreshStylesOnPage()"
                    [(colorPicker)]="getCurrentStyleItemColors().borderColor"
                    readonly
                  />
                  <span class="color-block__ngx-picker-title">{{ lg.colorCustomizer.borderColor }}</span>
                </label>
              }
            </div>
          }
        }
      </div>
    }
  </div>
}
